import { invalidateBulletinDetailsQuery } from "entities/bulletin/queries/useBulletinDetailsQuery";
import { BulletinDetailsTabs } from "entities/bulletin/types";
import React, { FC } from "react";
import Drawer from "shared/components/Drawer";
import { useBulletinBoardPage } from "../../context";
import ActionButton from "./components/ActionButton";
import General from "./components/General";
import SkeletonBulletinContent from "./components/General/skeleton";
import Tabs from "./components/Tabs";
import Translations from "./components/Translations";
import { BulletinDetailsProvider, useBulletinDetails } from "./context";

const BulletinDetailsDrawerContainer: FC = () => (
  <BulletinDetailsProvider>
    <BulletinDetailsDrawer />
  </BulletinDetailsProvider>
);

const BulletinDetailsDrawer: FC = () => {
  const { bulletinBoardDetailsDrawer } = useBulletinBoardPage();
  const { bulletinDetails, selectedTab, isLoadingBulletinDetails } =
    useBulletinDetails();

  const TAB_CONTENT: Record<BulletinDetailsTabs, FC> = {
    [BulletinDetailsTabs.General]: General,
    [BulletinDetailsTabs.Translations]: Translations,
  };
  const ContentComponent = TAB_CONTENT[selectedTab];

  return (
    <Drawer
      title={bulletinDetails?.title ? "Edit bulletin" : "Add new bulletin"}
      isOpen={bulletinBoardDetailsDrawer.isOpen}
      onCloseDrawer={() => {
        invalidateBulletinDetailsQuery(
          bulletinBoardDetailsDrawer.drawerDetails || "",
        );
        bulletinBoardDetailsDrawer?.closeDrawer();
      }}
      width={640}
      headingRight={<ActionButton />}
      headingBottom={<Tabs />}
    >
      {isLoadingBulletinDetails && <SkeletonBulletinContent />}
      {!isLoadingBulletinDetails && <ContentComponent />}
    </Drawer>
  );
};

export default BulletinDetailsDrawerContainer;
